export const ID_PREFIX = { GENERATION: "gen_generation_" } as const;
